import React from "react";
import MainLayout from "../../layout/MainLayout";
import CancerCalculateHeader from "../../layout/Header/CancerCalculateHeader";
import CancerMainFooter from "../../layout/Footer/CancerMainFooter";
import FormList from "./FormList";

const BreastForm = ({
  score,
  onSexChange,
  onKGChange,
  onAgeChange,
  onCmChange,
  onPageMove,
  inputElAge,
  inputElCm,
  inputElKg,
}) => {
  return (
    <MainLayout
      header={<CancerCalculateHeader cancer="유방암" />}
      footer={<CancerMainFooter onClick1={() => onPageMove()} />}
    >
      <FormList
        score={score}
        onSexChange={onSexChange}
        onKGChange={onKGChange}
        onAgeChange={onAgeChange}
        onCmChange={onCmChange}
        onPageMove={onPageMove}
        inputElAge={inputElAge}
        inputElCm={inputElCm}
        inputElKg={inputElKg}
      />
    </MainLayout>
  );
};

export default BreastForm;
